import { assignConditionalTokens, media } from '@sail/engine';
import { tokens } from '@sail/ui';
import { helmTokens } from './helmTokens';
import { columnPaddingTokens } from './layout';
export const columnPaddingTablet = assignConditionalTokens(media.up(tokens.viewport.small), helmTokens.layout.columnPadding, {
    medium: columnPaddingTokens.tablet.medium,
    large: columnPaddingTokens.tablet.large,
    xlarge: columnPaddingTokens.tablet.xlarge
});
export const columnPaddingDesktop = assignConditionalTokens(media.up(tokens.viewport.large), helmTokens.layout.columnPadding, {
    xlarge: columnPaddingTokens.desktop.xlarge
});

//# sourceMappingURL=assignedColumnPadding.js.map